export const quoteNaNTokens = (raw) => {
  let out = "";
  let i = 0;
  let inStr = false; // are we inside a "..." string?
  let esc = false; // previous char was a backslash inside a string?

  const isWS = (c) => c === " " || c === "\n" || c === "\r" || c === "\t";

  while (i < raw.length) {
    const ch = raw[i];

    // Handle string context
    if (inStr) {
      out += ch;
      if (esc) {
        esc = false; // escaped char consumed
      } else if (ch === "\\") {
        esc = true; // next char is escaped
      } else if (ch === '"') {
        inStr = false; // end of string
      }
      i++;
      continue;
    }

    // Entering a string?
    if (ch === '"') {
      inStr = true;
      out += ch;
      i++;
      continue;
    }

    // Outside string: look for a naked NaN token
    if (ch === "N" && raw.slice(i, i + 3) === "NaN") {
      // Check token boundaries so we don't touch parts of identifiers (not valid in JSON anyway)
      // Prev non-space must be one of start/[:,{, ,]  and next non-space must be one of ,}] or end
      let j = i - 1;
      while (j >= 0 && isWS(raw[j])) j--;
      const prev = j >= 0 ? raw[j] : null;

      let k = i + 3;
      while (k < raw.length && isWS(raw[k])) k++;
      const next = k < raw.length ? raw[k] : null;

      const prevOK = prev === null || prev === ":" || prev === "[" || prev === "{" || prev === ",";
      const nextOK = next === null || next === "," || next === "}" || next === "]";

      if (prevOK && nextOK) {
        out += '"NaN"'; // safely quote the token
        i += 3;
        continue;
      }
    }

    // Default copy
    out += ch;
    i++;
  }
  return out;
};

export const formatReadableDateTime = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const day = String(date.getDate()).padStart(2, "0");

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
